import { gql } from '@apollo/client';

/**
 * 「换单日统计查询」外部员工版本（HUB_OPERATOR / SORTING_STAFF 等一线角色调用）。
 * 与 GET_ORDER_REPRINT_DAILY_STATS 字段结构一致；用 GraphQL 别名保持响应字段名 `getOrderReprintDailyStats` 不变，
 * 下游可直接复用 OrderReprintDailyStatsResponse 类型。
 */
export const GET_ORDER_REPRINT_DAILY_STATS_FOR_EXTERNAL_STAFF = gql`
    query GetOrderReprintDailyStatsForExternalStaff(
        $hubId: Long
        $warehouseId: Long
        $startTime: Long
        $endTime: Long
        $accountId: Long
        $source: Int
    ) {
        getOrderReprintDailyStats: getOrderReprintDailyStatsForExternalStaff(
            hubId: $hubId
            warehouseId: $warehouseId
            startTime: $startTime
            endTime: $endTime
            accountId: $accountId
            source: $source
        ) {
            date
            total
            success
            failed
            successRate
            avgProcessingTimeMs
            errorDistribution {
                failureType
                count
            }
        }
    }
`;
